import { apiPaths } from '@core/http/apiPaths';
import { httpClient } from '@core/http/httpClient';
import { getPathPayload } from '@hwm/ui-lib';
import { AccessProfile } from '@models/AccessProfile';
import { IDmaResponse } from '@models/IDmaResponse';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

export const getAllDmas = createAsyncThunk(
  `accounts/getAllDmas`,
  async ({
    accountId,
    ...params
  }: {
    accountId: string;
    includeArchived?: boolean;
    orderBy?: string;
    ascending?: boolean;
  }) => {
    const response: AxiosResponse<IDmaResponse[]> = await httpClient.get(
      apiPaths.accounts.getDmaSummary({ accountId }),
      {
        params,
      }
    );

    return response.data;
  }
);

interface RemoveAccountThunk {
  accountId: number;
}

export const removeAccount = createAsyncThunk('accounts/removeAccount', async ({ accountId }: RemoveAccountThunk) => {
  const response = await httpClient.delete(apiPaths.accounts.getById({ accountId: accountId?.toString() }));

  return response.data;
});

export const fetchHasFlowLinks = createAsyncThunk(
  `accounts/fetchHasFlowLinks`,
  async (params: getPathPayload<typeof apiPaths.accounts.hasFlowLinks>) => {
    const response: AxiosResponse<boolean> = await httpClient.get(apiPaths.accounts.hasFlowLinks(params));

    return response.data;
  }
);

export interface GetAccessProfileThunk {
  id: number;
}

export const getAccessProfile = createAsyncThunk('users/accessProfile', async ({ id }: GetAccessProfileThunk) => {
  const response: AxiosResponse<AccessProfile> = await httpClient.get(apiPaths.users.getAccessProfile({ id }));

  return response.data;
});
